import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Two faces, one family (decision 2026-10-31): IBM Plex Sans for text and
// display, IBM Plex Mono for labels, data and the wordmark — see index.css.
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/400-italic.css"; // headline flourishes
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/500-italic.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css"; // buttons
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css"; // wordmark, labels
import "./index.css";
import App from "./App.tsx";
import { getPref } from "./prefs";
import { applyMix, applyMono, applyTheme, applyTouch, getStoredTheme } from "./theme";

// Apply the persisted theme, custom mix, accent mode and touch scaling before
// first paint so there is no flash.
applyTheme(getStoredTheme());
applyMix(getPref("mix"));
applyMono(getPref("mono"));
applyTouch(getPref("touch"));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
